<template>
  <div class="reservations">
    <div class="textBox1 wrapper">
      <div>
        <h4 v-scroll-reveal="LeftReveal1">your table is waiting</h4>
        <h1 v-scroll-reveal="LeftReveal2">Lets Eat!</h1>
      </div>
      <div v-scroll-reveal="bottomReveal">
        <p style="font-weight: 600">Monday to Saturday</p>
        <br />
        <p>1st Round 5:30 PM</p>
        <br />
        <p>2nd Round 9:30 PM</p>
        <br />
      </div>
    </div>

    <!-- RESERVATION SYSTEM -->
    <transition name="fade">
    <bookingForm />
    </transition>
    <router-link to="/contactUs">
      <nextPage page="Contact Us" class="contact" />
    </router-link>
    
  </div>
</template>

<script>
import nextPage from "../components/nextPage.vue";
import bookingForm from "../components/bookingForm.vue";

export default {
  name: "Reservations",
  components: {
    nextPage,
    bookingForm
  },
  data() {
    return {
      LeftReveal1: {
        duration: 800,
        delay: 400,
        distance: "20px",
        origin: "left"
      },
      LeftReveal2: {
        duration: 800,
        delay: 600,
        distance: "20px",
        origin: "left"
      },
      bottomReveal: {
        duration: 1200,
        delay: 800,
        distance: "20px",
        origin: "bottom"
      },
    }
  }
};
</script>

<style src="../styles/main.scss" lang="scss">
</style>
